<div
    class="agpr-paginator"
    [ngClass]="{'agpr-paginator--disabled': isDisabled}"
>
    <div class="agpr-paginatorItemsPerPageDropdown">
        <span class="agpr-paginatorItemsPerPageDropdown-localization">
            {{ 'Paginator.show' | localize }}
        </span>
        <div
            class="agpr-paginatorItemsPerPageDropdown-buttonContainer"
            (clickOutside)="closeItemsPerPageDropdown()"
            [attachOutsideOnClick]="true"
        >
            <button
                #dropdownTrigger
                pButton
                role="combobox"
                [id]="id + '.paginator.itemsPerPageDropdownButton'"
                class="agpr-paginatorItemsPerPageDropdown-button"
                [label]="itemsPerPageSelected + ' '"
                iconPos="right"
                icon="fa-solid fa-angle-down"
                [disabled] = "isDisabled"
                [attr.aria-label]="('Paginator.itemsPerPage' | localize) + itemsPerPageSelected"
                [attr.aria-expanded]="dropdownOpen"
                [attr.aria-controls]="id + 'paginator-dropdown'"
                (keydown)="onTriggerKeydown($event)"
                (keyup)="$event.stopPropagation()"
                (click)="toggleDropdown()"
            >
            </button>
            <ul
                *ngIf="dropdownOpen"
                role="listbox"
                [id]="id + 'paginator-dropdown'"
                class="agpr-paginatorItemsPerPageDropdown-selectItemContainer"
                agprListKeyboardNavigation
            >
                <li
                    *ngFor="let item of itemsPerPageOptions; index as i"
                    role="option"
                    [id]="id + '.paginator.itemsPerPageDropdownOption_' + i"
                    class="agpr-paginatorItemsPerPageDropdown-selectItem"
                    [ngClass]="{
                        'agpr-paginatorItemsPerPageDropdown-selectItem--selected' : +item.id == itemsPerPageSelected
                    }"
                    [attr.aria-selected]="+item.id == itemsPerPageSelected"
                    tabindex="-1"
                    (keydown)="onOptionKeydown(i, $event)"
                    (keyup)="$event.stopPropagation()"
                    (click)="item.command()"
                >
                    {{ item.id }}
                </li>
            </ul>
        </div>
    </div>

    <div class="agpr-paginatorNavigationButtons">
        <button
            class="agpr-paginatorNavigationButtons-button left"
            [id]="id + '.paginator.navigationButtonLeft'"
            (click)="pageBackClick()"
            [disabled]="backButtonDisabled || isDisabled"
            [attr.aria-label]="'Paginator.previous' | localize"
        >
            <span class="fa-solid fa-angle-left"></span>
        </button>
        <span>
            {{ 'Paginator.page' | localize }}
        </span>
        <input
            pInputText
            #pageInput
            class="agpr-paginatorNavigationButtons-input"
            [id]="id + '.paginator.pageInput'"
            type="number"
            min="1"
            [max]="totalNumberOfPages"
            [ngModel]="pageNumber"
            (blur)="onInput($event)"
            (keyup)="onKeyUp($event)"
            [disabled]="isDisabled"
            [attr.aria-labelledby]="id + '_paginator_pageInputLabel'"
        />
        <span class="sr-only" [id]="id + '_paginator_pageInputLabel'">
            {{ 'Paginator.pageNumberOfTotalPages' | localize: {totalPage: totalNumberOfPages} }}
        </span>
        <span>
            {{ 'Paginator.of' | localize }}
        </span>
        <span
            class="agpr-paginatorNavigationButtons-pageCount"
        >
            {{ totalNumberOfPages }}
        </span>
        <button
            class="agpr-paginatorNavigationButtons-button right"
            [id]="id + '.paginator.navigationButtonRight'"
            (click)="pageForwardClick()"
            [disabled]="forwardButtonDisabled || isDisabled"
            [attr.aria-label]="'Paginator.next' | localize"
        >
            <span class="fa-solid fa-angle-right"></span>
        </button>
    </div>
</div>

